module.exports = '<svg width="51" height="32" viewBox="0 0 51 32"><path d="M1.504 31.526c.96.576 2.144.64 3.137.128l14.563-7.301v4.452c0 1.12.576 2.144 1.504 2.721.96.576 2.144.64 3.137.128L49.45 18.855c1.088-.515 1.76-1.636 1.76-2.852s-.672-2.336-1.76-2.852L23.845.352A3.295 3.295 0 0 0 22.405 0c-.576 0-1.184.16-1.696.48a3.196 3.196 0 0 0-1.504 2.721v4.417L4.642.353a3.295 3.295 0 0 0-1.44-.352c-.576 0-1.184.16-1.696.48A3.196 3.196 0 0 0 .002 3.202v25.605c0 1.12.576 2.144 1.504 2.721z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/fast-forward-2.js
// module id = 1140
// module chunks = 14